export class SubmissionError extends Error {
    public readonly code?: string;

    public constructor(message: string, code?: string) {
        super(message);
        this.code = code;
    }
}
